<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Individuals</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16"
          >HealthCare Professional</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <b-modal
      id="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class="overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div>
          <div class="flex justify-between items-center pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              v-b-modal.editModal
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-modal>
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per relative">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full md:hidden lg:hidden block">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-h-MyIjZF-VqJ6n9c9p95r-1733403527"
              class="md:hidden lg:hidden block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Share your EXPERTISE with caregivers to help them understand
                their role.
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Register with us
                <!-- <a 
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> -->
                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('register')"
                  >Sign up</span
                >
              </p>
              <div class="flex pt-8">
                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> -->
                <base-button
                  type="primary"
                  class="paddingidentifybtn btntext mob-hidden"
                  @click="handleClick('register')"
                  >Sign up</base-button
                >
              </div>
            </div>
          </div>
          <div class="w-1/2 relative pb-24 mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-h-MyIjZF-VqJ6n9c9p95r-1733403527"
              class="m-auto custborderradius"
              alt="banner"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per relative">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full md:hidden lg:hidden block">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner2.jpg"
              class="md:hidden lg:hidden block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="lg:text-xl md:text-xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                <i class="text-primary">
                  “There are days when I have to control my overwhelming urge to
                  cry…there is no place or time for that… my next patient needs
                  me”
                </i>
                <br />– Prakash, 30yrs, Resident Intern at a hospital
              </p>
              <br />
              <p
                class="font-semibold fsize27 md-fsize20 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Your well-being matters too
              </p>
              <p
                class="fsize25 sm-fsize14 md-fsize18 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 mob-hidden"
              >
                It is challenging to provide professional care continuously.
                Benefit from our training courses, build resilience skills and
                learn methods to deliver effective care

                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> -->
              </p>
              <span
                class="underline text-4f0a4b min-hidden font-semibold"
                @click="handleScroll()"
                >Learn more</span
              >
              <div class="flex pt-8">
                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> -->
                <base-button
                  type="primary"
                  class="px-5 btntext mob-hidden"
                  @click="handleScroll()"
                  >Learn more</base-button
                >
              </div>
            </div>
          </div>
          <div class="w-1/2 relative pb-24 mob-hidden mt-4">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner2.jpg"
              class="m-auto custborderradius"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="relative h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-4 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner3.jpg"
              class="md:hidden lg:hidden block m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Prolonged care responsibilities make BURNOUT inevitable
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Unburden yourself by sharing your stories of strife with a
                community that gets you. Lean in, share and grow
                <span
                  @click="handleClick('register')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Register</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="px-8 btntext"
                  @click="handleClick('register')"
                  >Register</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner3.jpg"
              class="m-auto custborderradius"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-36 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner4.jpg"
              class="custborderradius m-auto md:block lg:block hidden"
              alt=""
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Banner4.jpg"
              class="md:hidden lg:hidden block custborderradius m-auto"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Get certified as a caregiver coach to be empanel
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Get an in-depth understanding of the challenges in the life of a
                caregiver to provide expert guidance

                <!-- <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/document/d/1jd5PDyKIGa4fE5enRrwCS_T7XClwYgSfI3TDNmHesQc/edit"
                >
                </a> -->
                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('coach')"
                  >Sign up</span
                >
              </p>
              <div class="flex pt-8">
                <a target="_blank" class="hover:text-white">
                  <base-button
                    @click="handleClick('coach')"
                    type="primary"
                    class="px-8 btntext mob-hidden"
                    >Sign up</base-button
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-button-prev homeswiper" slot="button-prev"></div>
      <div class="swiper-button-next homeswiper" slot="button-next"></div>
      <div class="swiper-pagination cust-posi bott-10" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 12000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      editModal: false,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleClick(name) {
      // this.$router.push({ name: name });
      if (Object.keys(this.user).length === 0) {
        // console.log(true);
        this.$router.push({ name: name });
      } else {
        // console.log(false);
        this.$swal.fire({
          title: "Registered",
          text: "You're already a registered member",
          icon: "info",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    handleScroll() {
      const el = document.getElementById("SolutionDiv2");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
  mounted() {
    if (Object.keys(this.user).length === 0) {
      // console.log(true);
    } else {
      // console.log(false);
    }
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .homeswiper.swiper-button-next {
    right: 25px !important;
  }

  .homeswiper.swiper-button-prev {
    left: 25px !important;
  }
  .bott-10 {
    bottom: 10%;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
}
</style>
